export default __webpack_public_path__ + "static/mathilde-roseanne-bregeon-812c0ebe05a2ab0d2b9630389f150fea.jpg";